module.exports = __webpack_public_path__ + "img/tomato-rice-1.1ddde82e.jpg";